module.exports = __webpack_public_path__ + "media/images/icons/SVG/020-843a30c0e30be203943d2f1399e3add2.svg";